module.exports = __webpack_public_path__ + "static/img/0.b8984ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/haqcs-as-a-controller-images/top-strip/0.png
// module id = 139
// module chunks = 1 2